<!--Todo, extract parts that are similar to share between wizard and modal-->

<div class="modal-header">
  <h4 class="modal-title pull-left">
    {{ 'watchlist.create_watchlist.create_watchlist' | translate }}
  </h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="watchlistForm">
    <div class="form-group">
      <label class="label" for="watchlist-name"> {{ 'watchlist.create_watchlist.watchlist_name' | translate }}</label>
      <input
        class="form-control"
        type="text"
        id="watchlist-name"
        required
        formControlName="name"
        name="watchlist-name" />
    </div>
    <div class="form-group">
      @if (
        watchlistForm.controls['name'] &&
        watchlistForm.controls['name'].invalid &&
        (!watchlistForm.controls['name'].pristine || showErrorMessage())
      ) {
        <div class="alert alert-warning">
          {{ 'watchlist.create_watchlist.watchlist_name_required' | translate }}
          <!--TODO: Make pretty-->
        </div>
      }
    </div>
    <div class="form-group">
      <label class="label"> {{ 'watchlist.create_watchlist.personal_or_shared' | translate }}</label>
      <p class="text-muted">
        <span [innerHTML]="'watchlist.create_watchlist.personal_shared_info_box' | translate"></span>
      </p>

      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="watchlist-personal"
          name="personal"
          formControlName="personal"
          [value]="true"
          checked />
        <label class="form-check-label" for="watchlist-personal">
          {{ 'common.personal' | translate }}
        </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          [attr.data-cy]="'watchlist-shared'"
          id="watchlist-shared"
          name="personal"
          formControlName="personal"
          [value]="false" />
        <label class="form-check-label" for="watchlist-shared">
          {{ 'common.shared' | translate }}
        </label>
      </div>
      <div class="form-group">
        @if (
          watchlistForm.controls['personal'] &&
          watchlistForm.controls['personal'].invalid &&
          (!watchlistForm.controls['personal'].pristine || showErrorMessage())
        ) {
          <div class="alert alert-warning">
            {{ 'watchlist.create_watchlist.type_required' | translate }}
            <!--TODO: Make pretty-->
          </div>
        }
      </div>
      @if (!isPersonal()) {
        <p class="text-muted">
          {{ 'watchlist.create_watchlist.shared_watchlist_description' | translate }}
        </p>
      }
      @if (isPersonal()) {
        <p class="text-muted">
          {{ 'watchlist.create_watchlist.personal_watchlist_description' | translate }}
        </p>
      }
    </div>
  </form>
</div>
<div class="modal-footer">
  <button nkButton (click)="cancel()">{{ 'common.cancel' | translate }}</button>
  <button nkButton color="success" [disabled]="createWatchlistDisabled()" (click)="onValidateCreateWatchlist()">
    {{ 'watchlist.create_watchlist.create_watchlist' | translate }}
  </button>
</div>
